<template>
  <b-container v-if="detail != null">
    <b-form>
      <b-form-row>
        <b-form-group label="Codice Punto Vendita" class="col-md-3">
          <b-form-input :value="detail.shopCode" disabled/>
        </b-form-group>
        <b-form-group label="Tipo di Domanda" class="col-md-3">
          <b-form-input :value="demandType(detail.demandType)" disabled/>
        </b-form-group>
        <b-form-group label="Codice Tessera" class="col-md-3">
          <b-form-input :value="detail.barcode" disabled/>
        </b-form-group>
        <b-form-group label="Codice Vecchia Tessera" class="col-md-3" v-if="detail.demandType === 'REISSUE'">
          <b-form-input :value="detail.oldBarcode" disabled/>
        </b-form-group>
      </b-form-row>
      <h4>Dati Identificativi</h4>
      <b-form-row>
        <b-form-group label="Cognome" class="col-md-6">
          <b-input-group>
            <b-form-input disabled :value="detail.lastName"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Nome" class="col-md-6">
          <b-input-group>
            <b-form-input disabled :value="detail.firstName"/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Sesso" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.sex"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Codice Fiscale" class="col-md-8">
          <b-input-group>
            <b-form-input :value="detail.fiscalCode" disabled/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Data di Nascita" class="col-md-4">
          <b-input-group>
            <b-form-datepicker
              v-model="detail.birthDate"
              :date-format-options="dateFormat"
              disabled locale="it-IT"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Luogo di Nascita" class="col-md-6">
          <b-input-group>
            <b-form-input v-if="isItalian(detail.birthPlaceNation)" disabled :value="detail.birthPlaceCity"/>
            <b-form-input v-if="!isItalian(detail.birthPlaceNation)" disabled :value="detail.birthPlaceNation"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Provincia di Nascita" class="col-md-2">
          <b-input-group>
            <b-form-input disabled :value="detail.birthPlaceProvince"/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <h4>Residenza</h4>
      <b-form-row>
        <b-form-group label="Via" class="col-md-8">
          <b-input-group>
            <b-form-input disabled :value="detail.street"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Numero Civico" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.civicNumber"/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="CAP" class="col-md-3" v-if="detail.residenceNation === 'Italy'">
          <b-input-group>
            <b-form-input disabled :value="detail.postalCode"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Città" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.town"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Provincia" class="col-md-2" v-if="detail.residenceNation === 'Italy'">
          <b-input-group>
            <b-form-input disabled :value="detail.province"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Nazione" class="col-md-3">
          <b-input-group>
            <b-form-input disabled :value="detail.nation"/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <h4>Contatti</h4>
      <b-form-row>
        <b-form-group label="Cellulare" class="col-md-6">
          <b-input-group>
            <b-form-input :value="formatMobilePhone()" disabled/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Telefono Fisso" class="col-md-6">
          <b-input-group>
            <b-form-input :value="detail.telephone" disabled/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Email" class="col-md-12">
          <b-input-group>
            <b-form-input :value="detail.email" disabled/>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <h4>Dati Familiari</h4>
      <b-form-row>
        <b-form-group label="Numero Membri Familiari" class="col-md-4">
          <b-form-input id="family-number" :value="detail.familyNumber" disabled/>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Data di Nascita Primo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child1BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Data di Nascita Secondo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child2BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Data di Nascita Terzo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child3BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
          </b-input-group>
        </b-form-group>

      </b-form-row>
      <h4>Consensi e Firma</h4>
      <b-form-row>
        <b-form-group class="col-md-6">
          <label>Consensi Forniti</label>
          <b-form-checkbox-group v-model="detail.selectedConsensuses" size="lg">
            <b-form-checkbox value="marketing" disabled>Marketing</b-form-checkbox>
            <b-form-checkbox value="profiling" disabled>Profilazione</b-form-checkbox>
            <b-form-checkbox value="cooperatives" disabled>Cooperativi</b-form-checkbox>
            <b-form-checkbox value="third-party" disabled>Terze parti</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-group label="Regolamento Firmato nella Data" class="col-md-4 offset-md-2">
          <b-form-datepicker :value="detail.signedAt" :date-format-options="dateFormat" disabled locale="it-IT"/>
        </b-form-group>
      </b-form-row>
      <b-row align-h="end" class="mr-2">
        <b-button @click="switchTab" id="digitalize-button" variant="primary">Digitalizza</b-button>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import demandsType from '@/DemandsType'
import eventBus from "@/EventBus";

export default {
  name: 'Summary',
  mounted() {
    eventBus.$on("secondary-data-filled", this.update)
    eventBus.$on("identification-data-filled", this.update)
    eventBus.$on("documents-data-filled", this.update)
  },
  data: () => ({
    detail: {},
    dateFormat: { 'day': 'numeric', 'month': 'numeric', 'year': 'numeric' }
  }),
  methods: {
    switchTab() {
      eventBus.$emit("switch-tab", 0)
      eventBus.$emit("digitalize", true)
    },
    update(value) {
      console.log(value)
      Object.assign(this.detail, value);
      console.log(this.detail)
      this.$forceUpdate()
    },
    demandType (demandType) {
      return demandsType.find(type => type.value === demandType).text
    },
    formatMobilePhone() {
      return this.detail.mobilePhone ? `${this.detail.mobilePhonePrefix} ${this.detail.mobilePhone}` : ""
    },
    isItalian(nation) {
      return nation == null || nation === 'ITALIA'
    }
  }
}
</script>
